/**
 * Texts for Training page
 */
export const trainingPageText = {
    title: 'Formation - CamAPS FX',
    titleMeta: 'Nous proposons une formation en ligne gratuite aux utilisateurs de CamAPS FX',
    descriptionMeta: 'Le programme d’éducation au diabète de Cambridge propose une formation certifiée en ligne gratuite pour les personnes atteintes de diabète de type 1, les parents et tuteurs, le personnel scolaire et les professionnels de la santé.',
    keywords: 'camaps Formation, camaps fx Formation,  ',
    localeMeta: 'fr_fr',
    mainHeader: 'Formation pro-santé',
    mainSubHeader: 'Accompagnez les personnes utilisant CamAPS FX grâce à une formation dispensée par des experts.',
    gettingStartedHeader: 'Premiers pas',
    step1Title: '<strong>Étape 1:</strong><br/>Téléchargez l\'application',
    step2Title: '<strong>Étape 2:</strong><br/>Créez un compte',
    step3Title: '<strong>Étape 3:</strong><br/>Commencez la formation essentielle dans l\'application',
    step4Title: '<strong>Étape 4:</strong><br/>Associez votre pompe et CGM choisis (avec l\'approbation de votre équipe soignante) ou explorez l\'application en <strong>mode virtuel</strong>',
    videoSrc: '/video/In-app training loop_1.mp4',
    certifiedTrainingTitle: 'Formation certifiée',
    trainingHeader: 'Formation certifiée',
    trainingHeader_2: 'Pour les professionnels de santé',
    trainingHeader_3: 'Formation des utilisateurs',
    trainingHeaderText: 'Formation en ligne GRATUITE pour CamAPS FX fournie par le Programme de Formation au Diabète de Cambridge.',
    websiteLink: 'https://www.camdiabtraining.com/account-sign-in.html',
    websiteLinkHeading: 'Formation du CDEP',
    getTrained: 'Vous former',
    trainingHeaderIat: 'Formation CamAPS FX',
    trainingHeaderTextIat: 'Complétez la formation essentielle intégrée à l\'application avant d\'utiliser l\'app CamAPS FX.',
    trainingSubHeaderOneIat: 'Premiers pas',
    trainingSubTextOneIat: 'Téléchargez l\'app CamAPS FX. <br>Créez un compte pour commencer la formation.',
    trainingSubHeaderTwoIat: 'Besoin d\'aide pour installer l\'app ?',
    trainingParaTwoStartIat: 'Visitez notre',
    trainingParaTwoEndIat: 'section d\'aide.',
    websiteLinkHeadingSupportIat: 'Support',
    trainingSubHeaderThreeIat: 'Ressources supplémentaires',
    animationsYpsoPumpText: 'Animations',
    animationsAndText: 'et',
    animationsDanaText: 'Animations (pompe Dana)',
    animationsFurtherText: 'Apprenez grâce à des visuels étape par étape.',
    webinarsText: 'Webinaires',
    webinarsFurtherText: 'Regardez des sessions animées par des experts sur l\'utilisation de l\'app.',
    websiteAnimationsYpsoPumpLink: 'https://www.camdiabtraining.com/view/27/mylife-YpsoPump-users.htm',
    websiteAnimationsDanaLink: 'https://www.camdiabtraining.com/view/25/Dana-insulin-pump-users.htm',
    websiteWebinarsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
};
